import React, { useMemo } from "react";
import {
    Box,
    Container,
    Grid,
    Dialog,
    DialogContent,
} from "@mui/material";

import useDraftSolutionDetail from "./useDraftSolutionDetail";

import SolutionDetailHeader from "../SolutionDetails/SolutionDetailHeader";
import SolutionDetailSidebar from "../SolutionDetails/SolutionDetailSidebar";
import SolutionDetailContent from "../SolutionDetails/SolutionDetailContent";
import { buildSections } from "../SolutionDetails/catalogDetailUtils";

import DraftSolutionActions from "./DraftSolutionActions";
import DraftStatusSection from "./DraftStatusSection";
import DraftFooterActions from "./DraftFooterActions";

import styles from "../../pages/main/CatalogDetailPage/CatalogDetailPage.module.css";
import default_theme from "assets/themes/themes";

const DraftSolutionDetails = ({
    open,
    draft,
    onClose,
    onEdit,
    onDelete,
    onUnpublish,
    isPublished = false,
    isDeleting = false,
}) => {
    const data = draft?.combinedData || {};

    const sections = useMemo(() => buildSections(data), [data]);
    const prioritySections = sections.filter((section) => section.priority);
    const otherSections = sections.filter((section) => !section.priority);

    const { activeTab, handleTabChange } = useDraftSolutionDetail({
        open,
        draft,
    });

    if (!draft) return null;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="xl"
            scroll="paper"
            PaperProps={{
                sx: {
                    width: "90vw",
                    maxWidth: "90vw",
                    height: "90vh",
                    maxHeight: "90vh",
                },
            }}
        >
            <DialogContent sx={{ p: 0 }}>
                <Box className={styles.pageWrapper}>
                    <Container maxWidth="xl">
                        <DraftSolutionActions
                            onBack={onClose}
                            styles={styles}
                        />

                        <SolutionDetailHeader
                            data={data}
                            styles={styles}
                        />

                        <Box className={styles.contentSection}>
                            <Grid container spacing={4}>
                                <Grid item xs={12} md={4}>
                                    <SolutionDetailSidebar
                                        data={data}
                                        isAuthenticated={true}
                                        styles={styles}
                                        title={isPublished ? "Project Details" : "Draft Details"}
                                        showRDD={false}
                                        showShare={false}
                                        showOverlay={false}
                                        extraContent={
                                            <>
                                                <DraftStatusSection
                                                    status={data.status}
                                                />

                                            </>
                                        }
                                    />
                                </Grid>

                                <Grid item xs={12} md={8}>
                                    <SolutionDetailContent
                                        prioritySections={prioritySections}
                                        otherSections={otherSections}
                                        activeTab={activeTab}
                                        handleTabChange={handleTabChange}
                                        styles={styles}
                                    />
                                </Grid>
                            </Grid>
                        </Box>

                        <DraftFooterActions
                            draft={draft}
                            isPublished={isPublished}
                            onEdit={onEdit}
                            onDelete={onDelete}
                            onUnpublish={onUnpublish}
                            isDeleting={isDeleting}
                        />
                    </Container>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default DraftSolutionDetails;